import type { Action } from 'redux';
import dash_api from '../../../../../main/support/dash_api';
import { ReduxAsyncAction } from '../../../../services/ReduxAsyncAction';
import type { GetTikTokSANAuthenticationUrlPayload } from '../TikTokSAN.types';

const GetTikTokSANAuthenticationUrl = new ReduxAsyncAction<
  'GET_TIKTOK_SAN_AUTHENTICATION_URL',
  void,
  GetTikTokSANAuthenticationUrlPayload
>('GET_TIKTOK_SAN_AUTHENTICATION_URL');
GetTikTokSANAuthenticationUrl.registerRequest(() => {
  return dash_api
    .get(`/v1/tiktok/get-auth-url?host=${window.location.protocol}//${window.location.host}`)
    .then(({ data }) => {
      return data;
    });
});
export const GET_TIKTOK_SAN_AUTHENTICATION_URL = GetTikTokSANAuthenticationUrl.actionNamespaceConstants;
export const getTikTokSANAuthenticationUrl = GetTikTokSANAuthenticationUrl.request;

export type GetTikTokSANAuthenticationUrlAction = Action<typeof GET_TIKTOK_SAN_AUTHENTICATION_URL.response> & {
  data: GetTikTokSANAuthenticationUrlPayload;
};
